import { FavoriteType, IFavoriteResponse } from '@kcftech/prometheustypescriptapiclient';
import { useUser } from 'contexts/UserContext';
import { useMemo } from 'react';

export type UseLocationFavoritesProps = Readonly<{
    corporationId: string | undefined;
    locationId: string | undefined;
}>;

export function showFavorite(
    favorite: IFavoriteResponse,
    corporationId: string | undefined,
    locationId: string | undefined
) {
    if (locationId && favorite.Location?.LocationId !== locationId) {
        return false;
    }

    if (corporationId && favorite.Corporation?.CorporationId !== corporationId) {
        return false;
    }

    return true;
}

export function useLocationFavorites({
    corporationId,
    locationId,
}: UseLocationFavoritesProps) {
    const { favorites } = useUser();

    return useMemo(
        () =>
            favorites?.filter(
                (favorite) =>
                    favorite.FavoriteType.FavoriteTypeName === FavoriteType.Location &&
                    showFavorite(favorite, corporationId, locationId)
            ) ?? [],
        [corporationId, favorites, locationId]
    );
}
